import React, { useState } from "react";
import { toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
} from "reactstrap";

import { useNavigate } from "react-router-dom";
import FaqService from "../../redux/services/faq.service";

toast.configure();

const CreateFaq = () => {
  const navigate = useNavigate();

  const [currentQuestion, setCurrentQuestion] = useState("");
  const [currentAnswer, setCurrentAnswer] = useState("");
  const [questionErr, setQuestionErr] = useState("");
  const [answerErr, setAnswerErr] = useState("");

  const handleValidation = (event) => {
    const inputValue = event.target.value.trim();

    const inputFieldName = event.target.name;
    if (inputFieldName === "question") {
      if (inputValue.length < 1) {
        setQuestionErr("Question is required!");
      } else {
        setQuestionErr("");
      }
    }

    if (inputFieldName === "answer") {
      if (inputValue.length < 1) {
        setAnswerErr("Answer is required!");
      } else {
        setAnswerErr("");
      }
    }
  };

  const updateHandler = (event) => {
    event.preventDefault();

    let errorCount = 0;
    if (
      currentQuestion === "" ||
      currentQuestion === null ||
      currentQuestion < 1
    ) {
      setQuestionErr("Question is required!");
      errorCount++;
    }

    if (currentAnswer === "" || currentAnswer === null || currentAnswer < 1) {
      setAnswerErr("Answer is required!");
      errorCount++;
    }

    if (errorCount > 0) {
      return;
    } else {
      const data = {
        question: currentQuestion,
        answer: currentAnswer,
      };

      FaqService.create(data)
        .then((response) => {
          toast("QNA Created successfully!", {
            transition: Slide,
            closeButton: true,
            autoClose: 3000,
            position: "top-right",
            type: "success",
          });
          navigate("/faq/list");
        })
        .catch((error) => {
          toast(error?.response?.data.message, {
            transition: Slide,
            closeButton: true,
            autoClose: 3000,
            position: "top-right",
            type: "error",
          });
        });
    }
  };

  return (
    <>
      <Card className="main-card  dashboard-card">
        <CardHeader className="card-header-sm">
          <div className="card-header-title font-size-lg text-capitalize fw-normal">
            Frequently Asked & Question
          </div>
        </CardHeader>
        <Form onSubmit={updateHandler}>
          <CardBody>
            <Row>
              <Col md="12">
                <FormGroup>
                  <Label for="name">
                    Question <span className="text-danger">*</span>
                  </Label>
                  <Input
                    invalid={questionErr !== "" ? true : false}
                    type="text"
                    name="question"
                    id="question"
                    onChange={(e) => setCurrentQuestion(e.target.value)}
                    placeholder="Question..."
                    value={currentQuestion ? currentQuestion : ""}
                    onKeyUp={handleValidation}
                  />
                  {questionErr !== "" && (
                    <FormFeedback>{questionErr}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <FormGroup>
                  <Label for="name">
                    Answer <span className="text-danger">*</span>
                  </Label>
                  <Input
                    invalid={answerErr !== "" ? true : false}
                    type="textarea"
                    name="rulesRegText"
                    id="rules"
                    onChange={(e) => setCurrentAnswer(e.target.value)}
                    placeholder="Answer..."
                    value={currentAnswer ? currentAnswer : ""}
                    onKeyUp={handleValidation}
                    onInput={(e) => {
                      e.target.style.height = "auto";
                      e.target.style.height = `${e.target.scrollHeight}px`;
                    }}
                  />
                  {answerErr !== "" && <FormFeedback>{answerErr}</FormFeedback>}
                </FormGroup>
              </Col>
            </Row>
          </CardBody>
          <CardFooter className="d-block">
            <Button
              className="me-2"
              color="link"
              onClick={() => {
                navigate(`/faq/list`);
              }}
            >
              Cancel
            </Button>
            <Button color="primary" type="submit">
              Save
            </Button>
          </CardFooter>
        </Form>
      </Card>
    </>
  );
};

export default CreateFaq;
